import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import styles from './ThemesTab.module.scss';
import ThemeCard from 'component/molecules/settings-theme/theme-cards/ThemeCard';
import Container from 'component/atom/container/Container';
import { useFetch } from 'hooks/useFetch';
import { settingsEndpoints } from 'hooks/endpoints';
import * as Yup from 'yup';
import { FormikProvider, useFormik } from 'formik';
import Loader from 'component/atom/loader/Loader';
import Checkbox from 'component/atom/forms/checkbox/Checkbox';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';
const ThemesTab = forwardRef(({ chatSettingsThemeData }, ref) => {
  const { data, refetch, isFetching } = useFetch(
    ['responseThemes'],
    settingsEndpoints.getResponseTheme()
  );
  const fetchedData = data?.data?.items || [];

  const validationSchema = Yup.object({
    responseThemeId: Yup.number().required('Required'),
  });

  const formik = useFormik({
    initialValues: {
      responseThemeId: chatSettingsThemeData?.data?.responseThemeId,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {},
  });

  useImperativeHandle(ref, () => ({
    submitForm: () => formik.submitForm(),
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  if (isFetching) {
    return <Loader isComponent />;
  }

  return (
    <FormikProvider value={formik}>
      <Container>
        {/* <div className={styles.setUp}>
          <p>Choose theme setup</p>

          <Checkbox
            label="Default"
            ischecked={formik.values.responseThemeId === 1 ? true : false}
            value={formik.values.responseThemeId === 1 ? true : false}
            onChange={() => {
              formik.setFieldValue('responseThemeId', 1);
            }}
            rounded
          />
        </div> */}
        {fetchedData?.length === 0 ? (
          <NoData />
        ) : (
          <ThemeCard
            data={fetchedData}
            chatSettingsThemeData={chatSettingsThemeData}
            id="responseId"
          />
        )}
      </Container>
    </FormikProvider>
  );
});

export default ThemesTab;
